import { ApiProperty } from "@nestjs/swagger";

export class ApaSizeMatrixBDto {
    
  @ApiProperty()
  id: number;

  @ApiProperty()
  buyMonth?: string;

  @ApiProperty()
  fdOf?: string;

  @ApiProperty()
  styleNumber?: string;

  @ApiProperty()
  styleType?: string;

  @ApiProperty()
  usaSize: string;

  @ApiProperty()
  chinaSizeMatrixtype?: string;

  @ApiProperty()
  chinaTopSize: string;

  @ApiProperty()
  chinaTopBodysize: string;

  @ApiProperty()
  chinaBottomSize: string;

  @ApiProperty()
  chinaBottomBodysize: string;

  @ApiProperty()
  koreaSizeMatrixtype?: string;

  @ApiProperty()
  koreaTopGeneric: string;

  @ApiProperty()
  koreaTopChest: string;

  @ApiProperty()
  koreaTopHeight: string;

  @ApiProperty()
  koreaBottomGeneric: string;

  @ApiProperty()
  koreaBottomWaist: string;

  @ApiProperty()
  koreaBottomHip: string;

  @ApiProperty()
  koreaAge?: string;

  @ApiProperty()
  ftyShk?: string;

  @ApiProperty()
  createdUser?:string;

  @ApiProperty()
  updatedUser?:string;

  @ApiProperty()
  isActive?:boolean;

  @ApiProperty()
  versionFlag?: number;


  @ApiProperty()
  updatedAt?: Date;

  @ApiProperty()
  createdAt?:Date

}

